import React from 'react';
import { GeneralDialog } from 'sharedComponents/GeneralDialog';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { IconInfoFilled } from 'svgIcons/MotionPortalIcons';
import colors from 'theme/_colors.scss';
import { deleteGatewayRequest } from './actions';
import { gatewayType as GatewayType } from '../constants';
import './style.scss';
import PropTypes from 'prop-types';
const DeleteGatewayComponent = ({ show, close, gatewayID, organizationID, onResetAssetInfo, gatewayType, gatewayFilter }) => {
    const { t: translate } = useTranslation();
    const dispatch = useDispatch();
    const isSmartOrMachGateway = gatewayType === GatewayType.CASSIA || gatewayType === GatewayType.MACHSENSER || gatewayType === GatewayType.ARUBA;

    const content = <div className='delete_gateway_dialog__content'>
        <div>{isSmartOrMachGateway ? translate('ABB.Powertrain.Frontend.DeleteGatewaySmartSensorDescription') : translate('ABB.Powertrain.Frontend.DeleteGatewayDescription')}</div>
    </div>;
    const getDeleteGatewayTitle = <h1 className='delete_gateway_dialog__title'>
        <IconInfoFilled color={colors.primaryInfo} />
        <span className='delete_gateway_dialog__title-text'>{translate('ABB.Powertrain.Frontend.gatewayDeleteTitle')}</span>
    </h1>;
    return (
        <GeneralDialog
            show={show}
            close={close}
            dialogClassName='delete_gateway_dialog'
            closeButton={true}
            title={getDeleteGatewayTitle}
            cancelButtonProps={{
                text: translate('ABB.Powertrain.Frontend.cancelLabel'),
            }}
            acceptButtonProps={{
                text: translate('ABB.Powertrain.Frontend.deleteLabel'),
                onClick: () => { dispatch(deleteGatewayRequest(gatewayID, organizationID, gatewayFilter)); close(); onResetAssetInfo(); },
            }}
            persistent={false}
        >
            {content}
        </GeneralDialog>
    );
};
DeleteGatewayComponent.propTypes = {
    show: PropTypes.bool,
    close: PropTypes.func,
    gatewayID: PropTypes.any,
    onResetAssetInfo: PropTypes.func,
    gatewayType: PropTypes.string,
    gatewayFilter: PropTypes.shape({
        type: PropTypes.string,
        subType: PropTypes.string
    }),
    organizationID: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default DeleteGatewayComponent;
